/**
 * Hook for using authenticated API service
 * Provides access to API service with authentication tokens
 */

import { apiService } from '../services/api';

/**
 * Hook that provides access to the API service
 * API service now handles authentication internally via inline token acquisition
 */
export const useApi = () => {
  // API service now handles tokens internally - no setup needed
  return apiService;
};
